<script setup>
import { computed } from 'vue';
import { I18nT, useI18n } from 'vue-i18n';
import SalesListRefreshStatus from './SalesListRefreshStatus.vue';

const props = defineProps({
  firstName: { type: String, default: '' },
  now: { type: [Date, String, Number], default: () => new Date() },
  loading: { type: Boolean, default: false },
  updatedAt: { type: [Date, String, Number], default: null },
});

const emit = defineEmits(['refresh']);
const { t } = useI18n();
const currentDate = computed(() =>
  new Intl.DateTimeFormat('pt-BR')
    .format(new Date(props.now))
    .replaceAll('/', '-')
);
</script>

<template>
  <section class="grid gap-4" data-testid="sales-overview-welcome">
    <div class="flex flex-wrap items-center justify-between gap-3 text-sm">
      <div class="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-2">
        <span class="shrink-0 text-lais-text-muted">{{ currentDate }}</span>
        <I18nT
          keypath="SALES.OVERVIEW.GREETING"
          scope="global"
          tag="p"
          class="text-lais-text-body"
        >
          <template #greeting>
            <strong class="font-bold text-lais-text">
              {{ t('SALES.OVERVIEW.GREETING_NAME', { name: firstName }) }}
            </strong>
          </template>
        </I18nT>
      </div>
      <SalesListRefreshStatus
        :loading="loading"
        :updated-at="updatedAt"
        @refresh="emit('refresh')"
      />
    </div>

    <article
      class="flex min-h-[102px] items-center rounded-lais border border-lais-border-soft bg-white px-4 py-3 shadow-lais-card sm:px-6"
    >
      <div class="flex min-w-0 items-center gap-5 sm:gap-12">
        <img
          src="~dashboard/assets/real-estate/sales-overview-welcome.png"
          :alt="t('SALES.OVERVIEW.CHANGELOG_IMAGE_ALT')"
          class="h-[70px] w-[63px] shrink-0 object-contain"
        />
        <p
          class="min-w-0 font-redHatDisplay text-lg font-bold text-lais-text sm:text-xl"
        >
          {{ t('SALES.OVERVIEW.WELCOME', { name: firstName }) }}
        </p>
      </div>
    </article>
  </section>
</template>
